<div class="flex flex-column gap-3">
  <div class="mapa-celulas__mapa" #mapa role="region" aria-label="Mapa de células"></div>

  @if (sinUbicar() > 0) {
    <p class="m-0 text-sm text-color-secondary">
      {{ sinUbicar() }} célula(s) sin ubicación. Revisá la dirección en Configuración.
    </p>
  }

  <p-table
    [value]="celulas()"
    [paginator]="celulas().length > 10"
    [rows]="10"
    size="small"
    [rowHover]="true"
    styleClass="p-datatable-sm"
  >
    <ng-template #header>
      <tr>
        <th>#</th>
        <th>Líder</th>
        <th>Dirección</th>
        <th>Día y horario</th>
      </tr>
    </ng-template>
    <ng-template #body let-celula>
      <tr
        [class.cursor-pointer]="!!celula.coordenadas"
        (click)="enfocar(celula)"
        (keydown.enter)="enfocar(celula)"
        [attr.tabindex]="celula.coordenadas ? 0 : null"
      >
        <td><span class="mapa-celulas__numero">{{ numero(celula) }}</span></td>
        <td>{{ celula.nombreLider }}</td>
        <td>
          {{ celula.direccion }}@if (celula.localidad) {, {{ celula.localidad }}}
          @if (!celula.coordenadas) {
            <p-tag severity="warn" value="Sin ubicación" styleClass="ml-2" />
          }
        </td>
        <td>{{ celula.dia }} {{ celula.horario }}</td>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td colspan="4" class="text-sm text-color-secondary">
          No hay células registradas. Los líderes las cargan desde Configuración.
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
